import { render } from "./ProductDescription.vue?vue&type=template&id=33cdfaa2&ts=true"
import script from "./ProductDescription.vue?vue&type=script&lang=ts"
export * from "./ProductDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__